import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-brand">
          <div className="footer-logo">
            <div className="footer-logo-icon">DG</div>
            <div>
              <div className="footer-logo-name">DataGreffe</div>
              <div className="footer-logo-sub">Annonces Légales - Côte d'Ivoire</div>
            </div>
          </div>
          <p className="footer-desc">
            Plateforme officielle de consultation des annonces légales publiées en Côte d'Ivoire. Recherchez facilement les informations sur les entreprises enregistrées.
          </p>
        </div>

        <div className="footer-col">
          <h4>Navigation</h4>
          <Link to="/">Accueil</Link>
          <Link to="/recherche">Rechercher</Link>
          <Link to="/aide">Aide</Link>
        </div>

        <div className="footer-col">
          <h4>Légal</h4>
          <Link to="/mentions-legales">Mentions légales</Link>
          <Link to="/confidentialite">Politique de confidentialité</Link>
          <Link to="/cgu">CGU</Link>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2026 DataGreffe - Côte d'Ivoire. Tous droits réservés.</p>
      </div>
    </footer>
  );
};

export default Footer;
